import { alpha } from '@mui/material';
import { useAppConstantsContext } from '@/context/AppConstants';
import { openReportInNewTab } from '@/reports/index';
import { Button, Text, Icons } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';

interface FraudReportCtaParams {
  phoneNumber?: string;
  email?: string;
}

export function FraudReportCta({ phoneNumber, email }: FraudReportCtaParams) {
  const {
    links: { baseUrl },
  } = useAppConstantsContext();

  const clickHandler = () => {
    if (phoneNumber) {
      return openReportInNewTab(
        { phone: phoneNumber || '', searchType: 'phone-fraud' },
        baseUrl
      );
    }
    return openReportInNewTab(
      { email: email || '', searchType: 'email-fraud' },
      baseUrl
    );
  };

  const { isMobile } = useScreenSize();

  return (
    <Button
      color="success"
      sx={(theme) => ({
        marginTop: theme.spacing(1.5),
        justifyContent: 'flex-start',
        borderColor: alpha(theme.palette.primary.main, 0.1),
      })}
      variant="outlined"
      data-cy="fraud-report-cta-button"
      onClick={clickHandler}
    >
      <Icons.AddCircle data-cy="fraud-report-cta-icon" />
      <Text ml={0.75} mr={0.75} data-cy="fraud-report-cta-text">
        More information for this {phoneNumber ? 'phone number' : 'email'}{' '}
        available
      </Text>
      <Text color="primary" fontWeight="bold" data-cy="fraud-report-cta-link">
        View Full {isMobile ? '' : 'FraudScan '}Report
      </Text>
    </Button>
  );
}
